import React from 'react';
import { injectStripe, CardElement } from 'react-stripe-elements';
import addPaymentMethod from 'controllers/payment/addPaymentMethod';
import deletePaymentMethod from 'controllers/payment/deletePaymentMethod';
import Loading from 'components/UI/Loading';
import './AccountSettings.scss'
import isEmpty from 'lodash/isEmpty'
import locale from './locale';

// This is how you modify the style of CardElement
// You can't do it with plain CSS
const cardElementStyle = {
  base: {
    iconColor: '#D2D2D2',
    fontWeight: 300,
    '::placeholder': {
      fontWeight: 300,
      color: '#D2D2D2',
      fontSize: '12px',
      lineHeight: '13px',
    }
  }
}

class PaymentForm extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      email: '',
      class: 'form-control email-input',
      processingPayment: false,
      isValidEmail: true,
      isValidCard: true
    }

    this.onSubmit = this.onSubmit.bind(this)
    this.onChangeEmail = this.onChangeEmail.bind(this)
  }

  onChangeEmail(event){
    let validation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (validation.test(event.target.value)) {
      this.setState({class: 'form-control email-input'})
    } else {
      this.setState({class: 'form-control email-input email-error'})
    }

    this.state.email = event.target.value
    this.setState({email: this.state.email})
  }
  onSubmit(ev){
    const {
      currentPaymentMethod,
      onPaymentMethodChanged
    } = this.props;
    const {isValidEmail} = this.state;
    ev.preventDefault();

    if(!this.state.email) {
      this.setState({class: 'form-control email-input email-error'})
      ev.preventDefault();
      return;
    }
    this.setState({processingPayment: true})
    if(isValidEmail){
      this.props.stripe.createToken().then((payload) => {
        if(payload.token){
          this.setState({isValidCard: true})
          addPaymentMethod({
            source: payload.token.id,
            email: this.state.email,
            set_default: 'set_default'
          })
            .then((res)=>{
              this.setState({processingPayment: false})
              if(res.result==='success' && isEmpty(currentPaymentMethod)){
                deletePaymentMethod(currentPaymentMethod.id)
                  .then((res)=>{
                    onPaymentMethodChanged();
                  })
              }else{
                onPaymentMethodChanged();
              }
            })
        }else {
          this.setState({isValidCard: false, processingPayment: false})
        }
      }).catch(() => {
        this.setState({isValidCard: false, processingPayment: false})
        return;
      })
    }

  }

  render() {
    const {processingPayment} = this.state;
    const currentLocale = localStorage.getItem('language')

    return (
      <div className='update-card-wrapper'>
        { 
          processingPayment &&
          <div className='loading-wrapper'>
            <Loading />
          </div>
        }
        <div className='email-section'>
          <div>{__('Email Address', 'checkoutform', null, true)}</div>
          <input placeholder='name@mail.com' className={this.state.class} type='email' value={this.state.email} onChange={this.onChangeEmail} />
        </div>
        <div className='card-section'>
          <div>{__('Credit Card', 'checkoutform', null, true)}</div>
          <CardElement className='stripe-cardnumber' style={cardElementStyle} />
        </div>
        <div className='secure-msg'>
          {__('All payments are processed through Stripe. The connection is secure and encrypted. We do not collect any of your information.', locale)}
          <a target='__blank' href={`/privacy-${currentLocale.toLowerCase()}`}>{__('Privacy Policy', locale)}</a>
        </div>
        <div className='update-btn'>
          <button className="btn btn-primary" onClick={this.onSubmit}>{__('Update', locale)}</button>
        </div>
      </div>
    );
  }
}

export default injectStripe(PaymentForm);



// WEBPACK FOOTER //
// ./src/containers/pages/AccountSettings/paymentForm.js